@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";

/* src/app/front-layout/location/location-details/location-details.component.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-wrapper {
  min-height: 100vh;
  padding-bottom: 50px;
}
.location-header {
  background:
    linear-gradient(
      135deg,
      #00729d 0%,
      #005a7d 100%);
  color: white;
  padding: 80px 20px 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.location-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="2" fill="rgba(255,255,255,0.1)"/></svg>');
  opacity: 0.3;
}
.location-header h1 {
  margin-top: 50px;
  font-size: 4.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  color: white;
}
.location-header p {
  font-size: 2.5rem;
  opacity: 0.95;
  position: relative;
  z-index: 1;
}
.container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 20px;
}
.breadcrumb {
  background: white;
  padding: 20px 0;
  margin-bottom: 40px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}
.breadcrumb ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.breadcrumb li {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
}
.breadcrumb li:not(:last-child)::after {
  content: "\203a";
  margin-left: 15px;
  color: #00729d;
  font-size: 1.8rem;
  font-weight: bold;
}
.breadcrumb a {
  color: #00729d;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}
.breadcrumb a:hover {
  color: #005a7d;
  text-decoration: underline;
}
.breadcrumb li:last-child {
  color: #666;
  font-weight: 600;
}
.main-content {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 40px;
  margin-top: 25px;
  margin-bottom: 60px;
}
.left-column {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.right-column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
}
.card h2 {
  color: #00729d;
  font-size: 3rem;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 4px solid #ffbf00;
  font-weight: 700;
}
.centre-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.info-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid #00729d;
}
.info-item i {
  color: #00729d;
  font-size: 2.3rem;
  margin-top: 5px;
  min-width: 30px;
}
.info-item div h3 {
  color: #00729d;
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: 700;
}
.info-item div p {
  color: #555;
  line-height: 1.8;
  font-size: 1.6rem;
}
.schedule-section {
  margin-bottom: 35px;
}
.schedule-section h3 {
  font-size: 2rem;
  color: #00729d;
  margin-bottom: 15px;
  font-weight: 700;
}
.schedule-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.schedule-table th,
.schedule-table td {
  padding: 14px 16px;
  border: 1px solid #e0e0e0;
  font-size: 1.5rem;
}
.schedule-table th {
  background: #00729d;
  color: #fff;
}
.schedule-table tr:nth-child(even) {
  background: #f8f9fa;
}
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-top: 25px;
}
.service-item {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
  border-left: 5px solid #ffbf00;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 114, 157, 0.2);
}
.service-item i {
  color: #00729d;
  font-size: 3rem;
  margin-bottom: 15px;
  display: block;
}
.service-item h3 {
  color: #00729d;
  font-size: 1.8rem;
  margin-bottom: 12px;
  font-weight: 700;
}
.service-item p {
  color: #666;
  font-size: 1.5rem;
  line-height: 1.7;
}
.map-container {
  width: 100%;
  height: 450px;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 25px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}
.map-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.photo-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 25px;
}
.photo-item {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  aspect-ratio: 4/3;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.photo-item:hover {
  transform: translateY(-5px);
}
.photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.photo-item:hover img {
  transform: scale(1.1);
}
.faq-list {
  margin-top: 25px;
}
.faq-item {
  border-bottom: 2px solid #e0e0e0;
  padding: 25px 0;
}
.faq-item:last-child {
  border-bottom: none;
}
.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 700;
  color: #00729d;
  font-size: 1.8rem;
  transition: color 0.3s ease;
}
.faq-question:hover {
  color: #005a7d;
}
.faq-question i {
  color: #ffbf00;
  font-size: 1.3rem;
  transition: transform 0.3s ease;
}
.faq-item.active .faq-question i {
  transform: rotate(180deg);
}
.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  color: #666;
  padding-top: 0;
}
.faq-item.active .faq-answer {
  max-height: 600px;
  padding-top: 20px;
}
.faq-answer p {
  font-size: 1.5rem;
  line-height: 1.8;
}
.cta-box {
  background:
    linear-gradient(
      135deg,
      #00729d 0%,
      #005a7d 100%);
  color: white;
  padding: 40px;
  border-radius: 30px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 114, 157, 0.3);
}
.cta-box h3 {
  font-size: 2.5rem;
  margin-bottom: 18px;
  font-weight: 700;
  color: white;
}
.cta-box p {
  margin-bottom: 25px;
  opacity: 0.95;
  font-size: 1.5rem;
  line-height: 1.7;
}
.cta-button {
  min-width: 200px;
  display: inline-block;
  background: #ffbf00;
  color: #00729d;
  padding: 16px 40px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  margin-top: 10px;
}
.offer-button {
  min-width: 220px;
  display: inline-block;
  background: #fdfdfd;
  color: #00729d;
  padding: 16px 40px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  margin-top: 10px;
}
.offer-button:hover {
  background: #e6ac00;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 191, 0, 0.4);
}
.cta-button:hover {
  background: #e6ac00;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 191, 0, 0.4);
}
.contact-info-box {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 10px;
  border-top: 5px solid #ffbf00;
}
.contact-info-box h3 {
  color: #00729d;
  margin-bottom: 20px;
  font-size: 2.4rem;
  font-weight: 700;
}
.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 18px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.contact-item:hover {
  transform: translateX(5px);
}
.contact-item i {
  color: #00729d;
  font-size: 2rem;
  min-width: 25px;
}
.contact-item a,
.contact-item span {
  color: #555;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 500;
}
.contact-item a:hover {
  color: #00729d;
}
.hours-list {
  list-style: none;
  margin-top: 20px;
}
.hours-list li {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 2px solid #f0f0f0;
  font-size: 1.5rem;
}
.hours-list li:last-child {
  border-bottom: none;
}
.hours-list .day {
  font-weight: 700;
  color: #00729d;
}
.hours-list .time {
  color: #666;
  font-weight: 500;
}
.cta-pv {
  display: none;
}
.book-btn {
  background-color: #00729d;
  padding: 8px 16px;
  color: #fff;
  border-radius: 99px;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
}
.book-btn:hover {
  background-color: #dec404;
}
.offers-strip {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px 22px;
  background:
    linear-gradient(
      135deg,
      #fff7e0,
      #ffe8b3);
  border: 1px dashed #ffbf00;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.strong {
  font-size: 18px;
  font-weight: 600;
  color: #0077b6;
}
.offers-text {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.3px;
  text-align: center;
}
.offers-claim-btn {
  background: #0077b6;
  color: #fff;
  border: none;
  padding: 10px 22px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.offers-claim-btn:hover {
  transform: translateY(-2px);
  background: #005a8c;
  box-shadow: 0 8px 22px rgba(255, 107, 53, 0.45);
}
@media (max-width: 1024px) {
  .main-content {
    grid-template-columns: 1fr;
  }
  .location-header h1 {
    font-size: 2.8rem;
  }
  .location-header p {
    font-size: 1.3rem;
  }
  .card h2 {
    font-size: 2rem;
  }
  .services-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}
@media (max-width: 768px) {
  .location-header {
    padding: 50px 15px 40px;
    margin-top: 0;
  }
  .location-header h1 {
    font-size: 2rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  .location-header p {
    font-size: 1.1rem;
  }
  .container {
    padding: 0 15px;
  }
  .breadcrumb {
    padding: 15px 0;
    margin-bottom: 25px;
  }
  .breadcrumb li {
    font-size: 0.9rem;
  }
  .breadcrumb li:not(:last-child)::after {
    margin-left: 8px;
    font-size: 1.2rem;
  }
  .main-content {
    gap: 25px;
    margin-top: 15px;
    margin-bottom: 40px;
  }
  .left-column {
    gap: 25px;
  }
  .right-column {
    gap: 20px;
  }
  .card {
    padding: 25px 20px;
    border-radius: 10px;
  }
  .card h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 3px solid #ffbf00;
  }
  .info-item {
    padding: 15px;
    gap: 12px;
  }
  .info-item i {
    font-size: 1.5rem;
    min-width: 25px;
  }
  .info-item div h3 {
    font-size: 1.3rem;
    margin-bottom: 8px;
  }
  .info-item div p {
    font-size: 1rem;
    line-height: 1.6;
  }
  .schedule-section h3 {
    font-size: 1.4rem;
    margin-bottom: 12px;
  }
  .schedule-table {
    display: block;
  }
  .schedule-table thead {
    display: none;
  }
  .schedule-table tbody {
    display: block;
  }
  .schedule-table tr {
    display: block;
    margin-bottom: 15px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    background: #f8f9fa;
  }
  .schedule-table td {
    display: block;
    border: none;
    padding: 8px 0;
    font-size: 0.95rem;
  }
  .schedule-table td:before {
    content: attr(data-label);
    font-weight: 700;
    color: #00729d;
    display: inline-block;
    width: 80px;
  }
  .schedule-table td:last-child {
    padding-top: 12px;
    text-align: center;
  }
  .book-btn {
    display: block;
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    text-align: center;
    padding: 10px 20px;
    font-size: 0.95rem;
  }
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .service-item {
    padding: 20px;
  }
  .service-item i {
    font-size: 2rem;
  }
  .service-item h3 {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  .service-item p {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  .map-container {
    height: 300px;
    margin-top: 20px;
  }
  .photo-gallery {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .faq-item {
    padding: 20px 0;
  }
  .faq-question {
    font-size: 1.1rem;
    gap: 10px;
  }
  .faq-question i {
    font-size: 1rem;
    flex-shrink: 0;
  }
  .faq-answer p {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  .cta-box {
    padding: 30px 20px;
    border-radius: 20px;
  }
  .cta-box h3 {
    font-size: 1.6rem;
    margin-bottom: 15px;
  }
  .cta-box p {
    font-size: 1rem;
    margin-bottom: 20px;
    line-height: 1.6;
  }
  .cta-button,
  .offer-button {
    padding: 12px 30px;
    font-size: 1.5rem;
    min-width: 160px;
  }
  .contact-info-box {
    padding: 20px;
  }
  .contact-info-box h3 {
    font-size: 1.6rem;
    margin-bottom: 15px;
  }
  .contact-item {
    padding: 12px;
    gap: 12px;
    margin-bottom: 12px;
  }
  .contact-item i {
    font-size: 1.3rem;
    min-width: 20px;
  }
  .contact-item a,
  .contact-item span {
    font-size: 0.95rem;
  }
  .hours-list li {
    font-size: 1rem;
    padding: 12px;
  }
  .cta-pv {
    display: flex;
    align-self: center;
    margin: 20px 15px;
    text-align: center;
    justify-content: center;
    font-weight: 600;
    font-size: 1.5rem;
    padding: 14px 30px;
  }
  .offers-strip {
    flex-direction: column;
    gap: 12px;
    padding: 15px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .strong {
    font-size: 1rem;
  }
  .offers-text {
    font-size: 0.9rem;
  }
  .offers-claim-btn {
    width: 100%;
    max-width: 220px;
    padding: 12px 24px;
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .location-header {
    padding: 40px 12px 35px;
  }
  .location-header h1 {
    font-size: 2.6rem;
    margin-top: 100px;
    margin-bottom: 12px;
  }
  .location-header p {
    font-size: 1.5rem;
  }
  .container {
    padding: 0 12px;
  }
  .breadcrumb {
    padding: 12px 0;
    margin-bottom: 20px;
  }
  .breadcrumb ul {
    gap: 8px;
  }
  .breadcrumb li {
    font-size: 1.5rem;
  }
  .breadcrumb li:not(:last-child)::after {
    margin-left: 6px;
    font-size: 1rem;
  }
  .card {
    padding: 20px 15px;
  }
  .card h2 {
    font-size: 1.3rem;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
  .info-item {
    padding: 12px;
    gap: 10px;
  }
  .info-item i {
    font-size: 1.3rem;
  }
  .info-item div h3 {
    font-size: 1.8rem;
  }
  .info-item div p {
    font-size: 1.2rem;
  }
  .schedule-section h3 {
    font-size: 1.5rem;
  }
  .schedule-table tr {
    padding: 10px;
    margin-bottom: 12px;
  }
  .schedule-table td {
    font-size: 1.2rem;
    padding: 6px 0;
  }
  .schedule-table td:before {
    width: 70px;
    font-size: 1.2rem;
  }
  .book-btn {
    font-size: 1.2rem;
    padding: 8px 16px;
  }
  .service-item {
    padding: 18px 15px;
  }
  .service-item i {
    font-size: 1.8rem;
    margin-bottom: 12px;
  }
  .service-item h3 {
    font-size: 1.8rem;
    margin-bottom: 8px;
  }
  .service-item p {
    font-size: 1.3rem;
  }
  .map-container {
    height: 250px;
  }
  .faq-item {
    padding: 15px 0;
  }
  .faq-question {
    font-size: 1rem;
  }
  .faq-question i {
    font-size: 0.9rem;
  }
  .faq-answer p {
    font-size: 0.85rem;
  }
  .cta-box {
    padding: 25px 18px;
  }
  .cta-box h3 {
    font-size: 1.4rem;
    margin-bottom: 12px;
  }
  .cta-box p {
    font-size: 0.9rem;
    margin-bottom: 18px;
  }
  .cta-button,
  .offer-button {
    padding: 11px 25px;
    font-size: 1.2rem;
    min-width: 140px;
  }
  .contact-info-box {
    padding: 18px 15px;
  }
  .contact-info-box h3 {
    font-size: 1.4rem;
  }
  .contact-item {
    padding: 10px;
    gap: 10px;
  }
  .contact-item i {
    font-size: 1.1rem;
  }
  .contact-item a,
  .contact-item span {
    font-size: 1.2rem;
    word-break: break-word;
  }
  .hours-list li {
    font-size: 1.2rem;
    padding: 10px;
  }
  .cta-pv {
    font-size: 1.5rem;
    padding: 12px 25px;
    margin: 15px 12px;
  }
  .offers-strip {
    width: 100%;
    padding: 12px;
    gap: 10px;
  }
  .strong {
    font-size: 1.8rem;
  }
  .offers-text {
    font-size: 1.5rem;
  }
  .offers-claim-btn {
    max-width: 200px;
    padding: 10px 20px;
    font-size: 1.1rem;
  }
}
@media (max-width: 360px) {
  .location-header h1 {
    font-size: 1.4rem;
  }
  .location-header p {
    font-size: 0.85rem;
  }
  .card h2 {
    font-size: 1.15rem;
  }
  .breadcrumb li {
    font-size: 0.75rem;
  }
  .service-item h3 {
    font-size: 1rem;
  }
  .service-item p {
    font-size: 0.8rem;
  }
  .cta-box h3 {
    font-size: 1.25rem;
  }
  .cta-button,
  .offer-button {
    font-size: 0.85rem;
    padding: 10px 20px;
  }
}
/*# sourceMappingURL=location-details.component.css.map */
